import React from 'react';
import cs from 'classnames';
import { capitalize } from 'swag-common/utils/strings';
import TextAlignmentIcon from 'assets/svg/text-alignment-icon.svg';
import TextAlignLeftIcon from 'assets/svg/text-align-left.svg';
import TextAlignCenterIcon from 'assets/svg/text-align-center.svg';
import TextAlignRightIcon from 'assets/svg/text-align-right.svg';
import { NotecardEditorSelectWrapper } from '../notecard-editor-select-wrapper';
import { NOTECARD_TEXT_ALIGNMENT_OPTIONS } from '../constants';
import animationClasses from './notecard-editor-select-alignment-animation.scss';
import classes from './notecard-editor-select-alignment.scss';
const ALIGNMENT = 'Alignment';
const buttonsData = [{
  key: NOTECARD_TEXT_ALIGNMENT_OPTIONS.LEFT,
  icon: TextAlignLeftIcon
}, {
  key: NOTECARD_TEXT_ALIGNMENT_OPTIONS.CENTER,
  icon: TextAlignCenterIcon
}, {
  key: NOTECARD_TEXT_ALIGNMENT_OPTIONS.RIGHT,
  icon: TextAlignRightIcon
}];
export const NotecardEditorSelectAlignment = ({
  textAlignment,
  isOpened,
  toggleOpened,
  changeEditorBlockDataBySelection
}) => {
  const icon = /*#__PURE__*/React.createElement("img", {
    src: TextAlignmentIcon,
    alt: "Text alignment",
    className: classes.icon
  });
  const alignmentLabel = textAlignment === null ? ALIGNMENT : capitalize(textAlignment);
  const applyTextAlignment = alignment => {
    changeEditorBlockDataBySelection({
      'text-align': alignment
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/React.createElement(NotecardEditorSelectWrapper, {
    isOpened: isOpened,
    animationClasses: animationClasses,
    name: alignmentLabel,
    icon: icon,
    toggleOpened: toggleOpened
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.contentContainer
  }, buttonsData.map(({
    key,
    icon
  }) => /*#__PURE__*/React.createElement("button", {
    className: cs(classes.button, {
      [classes.buttonSelected]: textAlignment === key
    }),
    onClick: () => applyTextAlignment(key),
    key: key
  }, /*#__PURE__*/React.createElement("img", {
    src: icon,
    alt: `Align ${key}`
  }))))));
};